import { Workspace } from '@anm/api/modules/team';
import { WorkspaceContext } from '@anm/contexts/WorkspaceContext';
import { toUrlParams } from '@anm/helpers/parseParams';
import pickBy from 'lodash/pickBy';
import { useContext, useEffect, useState } from 'react';

import { EditorUrlParams, OpenEditorAction } from '..';
import vtConfig from '../../../config';

const { urls } = vtConfig();

type UseEditorUrlProps = {
  action?: OpenEditorAction;
  templateId?: string;
  params?: EditorUrlParams;
};
const getEditorUrl = ({ action, workspace, params, templateId }: UseEditorUrlProps & { workspace: Workspace }) => {
  const newParams = pickBy(params, v => v !== undefined);
  const paramsWithValue = params ? `&${toUrlParams(newParams)}` : '';

  let actionParam = '';
  switch (action) {
    case 'edit': {
      actionParam = `p=${templateId}`;
      break;
    }
    case 'create': {
      actionParam = 'new=1';
      break;
    }
    case 'duplicate': {
      actionParam = `r=${templateId}`;
      break;
    }
  }

  return `${urls.editor}/#${actionParam}${paramsWithValue}&workspace=${workspace}`;
};

const useEditorUrl = ({ action, templateId, params }: UseEditorUrlProps) => {
  const { workspace } = useContext(WorkspaceContext);
  const [editorUrl, setEditorUrl] = useState(getEditorUrl({ action, templateId, params, workspace }));

  useEffect(() => {
    setEditorUrl(getEditorUrl({ action, templateId, params, workspace }));
  }, [templateId, action, params]);

  return editorUrl;
};

export default useEditorUrl;
